// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8140":"fd9ee415","8670":"fd9ee415","9628":"5c0f1342"}[chunkId] + ".chunk.css";
};